<template>
  <!-- TODO: add to library -->
  <div id="form-wrapper">
    <form
      v-if="status !== formStatuses.completed"
      id="contact-form"
      @submit="sendForm"
      method="post"
      :class="{ loading: status == 2 }"
    >
      <div class="overlay">
        <spinner />
      </div>
      <div class="input-field" v-if="errors.length">
        <b>Please correct the following error(s):</b>
        <ul>
          <li
            v-for="error in errors"
            :key="error"
          >
            {{ error }}
          </li>
        </ul>
      </div>
      <div class="input-field" :class="{ active: !!name, focused: focus.name }">
        <label class="form-label" for="name">Name</label>
        <input
          id="name"
          v-model="name"
          :disabled="disabled"
          type="text"
          name="name"
          placeholder="Name *"
          @focus="focus.name = true"
          @blur="focus.name = false"
        >
      </div>
      <div class="input-field" :class="{ active: !!email, focused: focus.email }">
        <label class="form-label" for="email">Email</label>
        <input
          id="email"
          v-model="email"
          :disabled="disabled"
          type="email"
          name="email"
          placeholder="Email *"
          @focus="focus.email = true"
          @blur="focus.email = false"
        >
      </div>
      <div class="input-field" :class="{ active: !!phone, focused: focus.phone }">
        <label class="form-label" for="phone">Phone</label>
        <input
          id="phone"
          v-model="phone"
          :disabled="disabled"
          type="tel"
          name="phone"
          placeholder="Phone"
          @focus="focus.phone = true"
          @blur="focus.phone = false"
        />
      </div>
      <div class="input-field" :class="{ active: !!spouse, focused: focus.spouse }">
        <label class="form-label" for="spouse">Spouse/Partner</label>
        <input
          id="spouse"
          v-model="spouse"
          :disabled="disabled"
          type="text"
          name="spouse"
          placeholder="Spouse/Partner"
          @focus="focus.spouse = true"
          @blur="focus.spouse = false"
        />
      </div>
      <div class="input-field" :class="{ active: !!address, focused: focus.address }">
        <label class="form-label" for="address">Address</label>
        <input
          id="address"
          v-model="address"
          :disabled="disabled"
          type="text"
          name="address"
          placeholder="Address"
          @focus="focus.address = true"
          @blur="focus.address = false"
        />
      </div>
      <div class="input-field" :class="{ active: !!message, focused: focus.message }">
        <label class="form-label" for="message">Project Details</label>
        <textarea
          id="message"
          :disabled="disabled"
          v-model="message"
          name="message"
          placeholder="Project Details *"
          @focus="focus.message = true"
          @blur="focus.message = false"
        ></textarea>
      </div>
      <div class="input-field input-field-submit">
        <input type="submit" value="Submit" :disabled="disabled">
      </div>
    </form>
    <div v-if="status === formStatuses.completed">
      <h2>
        Your message has been recieved!
        A copy of your message has been sent to you for your records.
      </h2>
    </div>
  </div>
</template>

<script>
import Spinner from '@/components/Spinner';

export default {
  name: 'ContactForm',
  components: {
    Spinner,
  },
  data: () => ({
    errors: [],
    name: null,
    email: null,
    phone: null,
    spouse: null,
    address: null,
    message: null,
    focus: {
      name: false,
      email: false,
      phone: false,
      spouse: null,
      address: null,
      message: false,
    },
    formStatuses: {
      initialized: 0,
      started: 1,
      submitting: 2,
      completed: 3,
    },
    status: 0,
  }),
  computed: {
    disabled() {
      return this.status >= this.formStatuses.submitting;
    },
  },
  props: {
    apiEndpoint: {
      type: String,
      default: 'https://mattbensondev.com/leads',
    },
  },
  methods: {
    sendForm(e) {
      e.preventDefault();
      if (this.name && this.email && this.message) {
        const {
          name,
          email,
          phone,
          spouse,
          address,
          message,
        } = this;
        this.status = this.formStatuses.submitting;

        const internationalNumber = `+1${phone}`;

        const formData = {
          name,
          email,
          phone: internationalNumber,
          spouse,
          address,
          message,
        };

        fetch(this.apiEndpoint, {
          method: 'post',
          body: JSON.stringify(formData),
        }).then(async (res) => {
          if (res.status >= 200 && res.status < 300) {
            this.status = this.formStatuses.completed;
          } else {
            // TODO: if error response put the errors - otherwise bomb message
            const errorResponse = await res.json();
            this.errors.push(errorResponse.errors);
          }
        }).catch((err) => {
          this.status = this.formStatuses.started;
          console.error(err);
        });
      }

      this.errors = [];

      if (!this.name) {
        this.errors.push('Name required.');
      }
      if (!this.email) {
        this.errors.push('Email required.');
      }
      if (!this.message) {
        this.errors.push('Project Details required.');
      }

      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
#form-wrapper {
  height: 100%;
}

form {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .input-field {
    position: relative;
    margin-top: 24px;

    &.focused {
      input, textarea {
        border: 2px solid #333;
        outline: none;
      }

      input::placeholder, textarea::placeholder {
        color: transparent;
      }
    }

    &:not(.focused) {
      input, textarea {
        margin-top: 1px;
        margin-bottom: 1px;
      }
    }

    &.focused, &.active {
      input, textarea {
        padding: 25px 10px 5px 10px;
      }

      label {
        display: block;
        position: absolute;
        top: 3px;
        left: 10px;
        margin-top: 0px;
        font-size: 13px;
      }
    }
  }

  input:not([type="submit"]), textarea {
    border: 1px solid #B0B0B0;
    border-radius: var(--rc);
    color: #222;
    font-size: 16px;
    width: 100%;
    max-width: 100%;
    margin: 0;
    transition: box-shadow 0.5s, border-color 0.25s ease-in-out;
  }

  textarea {
    resize: vertical;
  }

  input[type="text"], input[type="email"], input[type="date"], input[type="tel"], textarea {
    padding: 15px 25px 15px 10px;
  }

  .input-field-submit {
    text-align: right;

    input[type="submit"] {
      width: auto;
    }
  }
}

label {
  display: none;
}

.overlay {
  display: none;
}

.loading {
  filter: blur(1px);

  .overlay {
    display: flex;
    align-items: center;
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: gray;
    border-radius: var(--rc);
    opacity: 0.8;
    z-index: 1;
  }
}
</style>
